import { render } from "./PageLogo.vue?vue&type=template&id=11b5f5dc"
const script = {}

import "./PageLogo.vue?vue&type=style&index=0&id=11b5f5dc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__